"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsWix = exports.IsWixContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.IsWixContext = react_1.default.createContext(false);
var useIsWix = function () {
    return react_1.default.useContext(exports.IsWixContext);
};
exports.useIsWix = useIsWix;
//# sourceMappingURL=index.js.map